import { render, staticRenderFns } from "./TitleRemark.vue?vue&type=template&id=75c91c99&scoped=true"
import script from "./TitleRemark.vue?vue&type=script&lang=js"
export * from "./TitleRemark.vue?vue&type=script&lang=js"
import style0 from "./TitleRemark.vue?vue&type=style&index=0&id=75c91c99&scoped=true&lang=css"
import style1 from "./TitleRemark.vue?vue&type=style&index=1&id=75c91c99&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75c91c99",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\cxy\\project\\zcy\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('75c91c99')) {
      api.createRecord('75c91c99', component.options)
    } else {
      api.reload('75c91c99', component.options)
    }
    module.hot.accept("./TitleRemark.vue?vue&type=template&id=75c91c99&scoped=true", function () {
      api.rerender('75c91c99', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/chart/view/TitleRemark.vue"
export default component.exports